// extracted by mini-css-extract-plugin
module.exports = {"particles":"particle-effect_particles_53TPu","wrapper":"particle-effect_wrapper_45_Fc","content":"particle-effect_content_1O5r9","canvas":"particle-effect_canvas_HwqAJ"};